module.exports = __webpack_public_path__ + "static/media/img06.0157e3c8.JPG";